/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {Fragment} from "react";
import {ListPaymentsRequest, ListUsersRequest, Payment} from "../../http/protocol";
import {PaymentService} from "../../services/PaymentService";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {ColumnType} from "../list/list/ColumnType";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {ActionType} from "../list/list/DataTable";
import {Validators} from "../form/Validators";
import {SelectInput} from "../form/SelectInput";
import {Link} from "react-router-dom";
import {withRouter} from "react-router";
import {Alert} from "../form/Alert";
import {getContainer} from "../../ioc/IOCSetup";
import { formatDate } from "../../util/date";
import Feedback from "react-bootstrap/esm/Feedback";

interface State extends ListViewState<ListPaymentsRequest> {
    listRequest?: ListPaymentsRequest;
    form?: ListPaymentsRequest;
    validationMap?: any;
    lookupId?: string;
    lookupError?: string;
    pendingWithdraws?:number;
    failedPayments?:number;
    lookupExpanded?:boolean;
}

interface Props extends ListViewProps{
}

/*function paymentLinkFactory(id: number): any {
    return <Link key={"action" + id} to={`/payment/${id}`} className="btn btn-primary btn-sm">Details</Link>;
}*/

function userLinkRenderer(prop : any , name : any, item : any) : any {
    if (item.userId) {
        return <Link key={"user-action" + item.userId} to={`/user/${item.userId}`}>{item.userId}</Link>;
    } else {
        return <div>n/a</div>;
    }
}

function amountRenderer(prop : any, name : any, item : any) : any{
    return <div>{item.amount} {item.currency}</div>
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const uidFactory = (uid: string) => <code>{uid}</code>;

export class PaymentListView extends ListView<State, ListPaymentsRequest> implements FormListener<ListPaymentsRequest> {
    statuses:string[] = ["FAILED_PERMANENTLY", "COMPLETED", "FAILED", "DECLINED", "CANCELED", "INITIATED", "PENDING", "RESOLVED"];

    columns = [
        { property : "id", name : "Id", orderBy : "id"},
        { property : "created", name : "Created", type : ColumnType.DATE},
        { property : "userId", name : "User Id", renderer: userLinkRenderer },
        { property : "type", name : "Type" },
        { property : "provider", name : "PSP", renderer: (property: string, name: string, item: any) => {
                let payment : Payment = Object.assign({}, item);
                if(payment.attributes !==undefined && payment.attributes.PSP_NAME !==undefined){
                    return payment.attributes.PSP_NAME;
                }
                return "";
            }
         },
        { property : "provider", name : "Provider" },
        { property : "amount", name : "Amount", renderer: amountRenderer },
        { property : "fee", name : "Fee", renderer: (property: string, name: string, item: any) => {
                if(item.fee===undefined){
                    return <span>{0}</span>;
                }
                return item.fee;
            }  
        },
        { property : "status", name : "Status" },
        { property: "request", name: "Last Update", 
            renderer: (property: string, name: string, item: any) => {
                if(item!== undefined && item.status!==undefined){
                    if(item.status==="COMPLETED" || item.status==="FAILED" 
                    || item.status==="CANCELED" || item.status==="RESOLVED"){
                        return <span>{formatDate(item.updated)}</span>
                    }
                }
            } 
        },
        { property : "mostRecentNoteText", name : "Notes", type: ColumnType.NOTE },
    ];


    paymentService : PaymentService;

    constructor(props : Props){
        super(props, "/payments");
        this.paymentService = getContainer().getPaymentService();
        let locProp = this.props.location;
        let storedForm = localStorage.getItem("paymentListForm") || undefined;
        if (this.state.listRequest){
            let statuses, types, userId = undefined;
            if(locProp.state && locProp.state.listRequest) {
                statuses = locProp.state.listRequest.statuses && locProp.state.listRequest.statuses;
                types = locProp.state.listRequest.types && locProp.state.listRequest.types;
                userId = locProp.state.listRequest.userId && locProp.state.listRequest.userId;
            }
            let initialForm:{};
            if(storedForm !== undefined && locProp.state === undefined) {
                initialForm = JSON.parse(storedForm);
            } else {
                initialForm = {
                    limit: 20,
                    orderBy: "id",
                    userId: userId === undefined ? "" : userId,
                    types: types === undefined ? ["DEPOSIT","WITHDRAWAL", "BONUS"] : types,
                    statuses: statuses === undefined ? this.statuses : statuses,
                    ascending: false
                };
            }
            this.state = createInitialState(
                initialForm,
                this.state = {lookupExpanded:false, ...this.state});
        }
    }

    componentDidMount() {
        this.props.history.replace("/payments/list")
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    formDidUpdate(formModel: ListUsersRequest, validationMap : any): void {
        this.setState({ form : formModel, validationMap : validationMap});
    }

    onSubmitError(): void {

    };

    onSubmit(): void {
        if (this.state.form){
            let listRequest = this.state.form;
            listRequest.offset = 0;
            listRequest.orderBy = "id";
            this.updateListState(listRequest);
        }
        this.props.history.replace("/payments/list")
    };

    onStatusesChanged(statuses: string[]) {
        let newReq = Object.assign({}, this.state.listRequest, { statuses: statuses });
        this.setState({ listRequest: newReq });
    }

    pagerChanged(pager : PagerModel) {
        if (this.state.listRequest) {
            var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
            this.setState({listRequest : listRequest});
        }
    }

    onAction(item : Payment, action : string) : Promise<any> | undefined {
        if (action === "details") {
            this.navigate("/payment/" + item.id);
        }
        return;
    }

    // onAction(item: Payment, action: string): Promise<any> | undefined {
    //     return;
    // }

    preset(e:any, preset: "default" | "failed" | "all" | "completed" | "canceled") {
        e.preventDefault();
        let userId = this.state.listRequest && this.state.listRequest.userId  ? this.state.listRequest.userId : "";
        let types = (this.state.form && this.state.form.types) || [];
        let sort: any = {
            limit: 50,
            orderBy: "id",
            ascending: false,
        };

        let filter;

        switch(preset) {
            case "default":
                filter = { types: types, statuses: ["PENDING", "INITIATED"], userId: userId};
                break;

            case "failed":
                filter = { types: types, statuses: ["FAILED_PERMANENTLY", "FAILED"], userId: userId};
                break;

            case "completed":
                filter = { types: types, statuses: ["COMPLETED", "RESOLVED"], userId: userId};
                break;

            case "canceled":
                filter = { types: types, statuses: ["CANCELED", "DECLINED"], userId: userId};
                break;

            case "all":
                filter = { types: types, statuses:this.statuses, userId: userId};
                break;
        }


        this.updateListState({...sort, ...filter});
        this.props.history.replace("/payments/list")
    }

    handleLookupValueChanged(event : any) {
        let value = event.target.value;        
        this.setState({lookupId: value});
    }

    async lookup(type: "id" | "uid") {
        if (!this.state.lookupId){
            return;
        }

        let payment : Payment={id:0};
        if (type === "id") {

            if (isNaN(this.state.lookupId as any)) {
                this.setState({ lookupError: "Id must be numeric" });
                return;
            }
            
            try {
                payment = await this.paymentService.getPaymentById(parseInt(this.state.lookupId)) as Payment;
            } catch (e) {
                // do nothing
            }
        } else if (type === "uid") {
            try {
                payment = await this.paymentService.getPaymentByUid(this.state.lookupId) as Payment;
            } catch (e) {
                // do nothing
            }
        }
            
        if (payment == null) {
            this.setState({ lookupError: "Payment not found" });
        } else {
            this.navigate("/payment/" + payment.id);
        }
    }

    getTitle() {
        return "Payments";
    }

    renderLookupForm() {
        return (
            <div className="card-box expandable-box" style={!this.state.lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}}>
                {this.state.lookupExpanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : false})}><i className="mdi mdi-minus"></i></a>
                )}
                {!this.state.lookupExpanded && (
                    <a  className="expand-button float-right" onClick={()=>this.setState({lookupExpanded : true})}><i className="mdi mdi-plus"></i></a>
                )}

                <h4 className="header-title mb-3" onClick={()=>this.setState({lookupExpanded : !this.state.lookupExpanded})}>Lookup Payment</h4>

                {this.state.lookupExpanded && (
                    <div>
                        { this.state.lookupError  &&
                        <Alert type="danger" text={this.state.lookupError} />
                        }
                        <form className="form-horizontal">
                            <FormGroup className="form-group">
                                <label className="col-lg-1 control-label">UUID</label>
                                <div className="col-lg-12">
                                    <input className="form-control" placeholder="dc3a1af6-c138-4475-a372-e64bb5bb4a1a" onChange={this.handleLookupValueChanged.bind(this)}/>
                                    <span className={"help-text"}>Search for Payments by UUID</span>
                                </div>
                            </FormGroup>
                            <FormGroup className="form-group">
                                <div className="col-lg-offset-1 col-lg-4">
                                    <button className="btn btn-primary" type="button" onClick={this.lookup.bind(this, "uid")}>By UUID</button>
                                </div>
                            </FormGroup>
                        </form>
                    </div>
                )}
            </div>
        );        
    }

    renderFilterForm() {
        return (
            <div className="card-box">
                <h4>Filter Payments</h4>
                    <Form className="form" formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                        <div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <FormGroup className="form-group">
                                        <h5>User ID</h5>
                                        <FormInput className="form-control" model="userId" type="integer" placeholder="User Id" validators={[Validators.integer()]}/>
                                    </FormGroup>

                                    <FormGroup className="form-group">
                                        <h5>Type</h5>
                                        <SelectInput className="form-control" multiple={true} size={2} model="types" values={["DEPOSIT", "WITHDRAWAL"]} >
                                        </SelectInput>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-8">
                                    <FormGroup className="form-group">
                                        <h5>Presets</h5>
                                        <div>
                                            <button className="btn btn-sm btn-spacing btn-primary" onClick={(e) => this.preset(e,"default")}>Ongoing</button>
                                            <button className="btn btn-sm btn-spacing btn-primary" onClick={(e) => this.preset(e,"all")}>All</button>
                                            <button className="btn btn-sm btn-spacing btn-primary" onClick={(e) => this.preset(e,"completed")}>Complete</button>
                                            <button className="btn btn-sm btn-spacing btn-primary" onClick={(e) => this.preset(e,"canceled")}>Canceled</button>
                                            <button className="btn btn-sm btn-spacing btn-primary" onClick={(e) => this.preset(e,"failed")}>Failed</button>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                        <h5>Status</h5>
                                        <SelectInput className="form-control" model="statuses" size={7} multiple={true} 
                                            values={this.statuses}>
                                        </SelectInput>                                        
                                    </FormGroup>
                                </div>
                            </div>

                            <input className="btn btn-primary" value="List Payments" type="submit" style={{marginRight:"15px"}}/>
                            <button className="btn-xs btn-new-default" onClick={(e) => this.clearForm(e)}>Clear filters</button>
                        </div>
                    </Form>
            </div>
        );        
    }

    clearForm(e:any) {
        e.preventDefault();
        return this.setState({form:{}});
    }
  

    renderContent() {
        if (!this.state.listRequest) {
            return <div />;
        }
        return (
            <Fragment>
                <div>
                    <div className="wrapper wrapper-content">

                        {this.renderFilterForm()}
                        {this.renderLookupForm()}

                        <EntityDataTable service={this.paymentService} 
                            onPagerChange={this.pagerChanged.bind(this)} 
                            columns={this.columns}
                            listRequest={this.state.listRequest} 
                            onAction={this.onAction.bind(this)}
                            actions={
                                [
                                    { id: "details", name: "Details", className: "btn btn-primary", type: ActionType.LINK, getLink: (item: any) => {
                                            localStorage.setItem("paymentListForm", JSON.stringify(this.state.listRequest));
                                            return "/payment/" + item.id
                                        } },
                                ]
                            }/>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default withRouter(PaymentListView);